const countDown = {
	el: {
		timerDays: document.querySelector('.js-countdown-days'),
		timerHours: document.querySelector('.js-countdown-hours'),
		timerMinutes: document.querySelector('.js-countdown-minutes'),
		timerSeconds: document.querySelector('.js-countdown-seconds'),
		dateToStart: document.querySelector('[data-start]')
	},

	constants: {
		days: 86400, //24 * 60 * 60
		hours: 3600, //60 * 60
		minutes: 60, //60 * 1
		seconds: 1, // 1
		miliseconds: 1000 //1 * 1000
	},

	time: {},

	fxCalculateTime() {
		const dateStart = new Date(this.el.dateToStart.dataset.start),
			dateToday = new Date()

		let delta = Math.abs(dateStart - dateToday) / this.constants.miliseconds

		Object.keys(this.constants).forEach(key => {
			this.time[key] = Math.floor(delta / this.constants[key])
			delta -= this.time[key] * this.constants[key]
		})

		const { days, hours, minutes, seconds } = this.time

		this.el.timerDays.innerText = String(days).padStart(2, 0)
		this.el.timerHours.innerText = String(hours).padStart(2, 0)
		this.el.timerMinutes.innerText = String(minutes).padStart(2, 0)
		this.el.timerSeconds.innerText = String(seconds).padStart(2, 0)

	},

	init() {
		if (this.el.dateToStart) {
			this.fxCalculateTime()
			setInterval(() => this.fxCalculateTime(), this.constants.miliseconds)
		}
	}
}

countDown.init()